import axios from 'axios';
import store from '../store';


const apiUrl = `https://${process.env.VUE_APP_API_CLIENT}.${process.env.VUE_APP_API_SERVER}/api/${process.env.VUE_APP_API_VERSION}/connector/`;
const apiUrl2 = `https://${process.env.VUE_APP_API_CLIENT}.${process.env.VUE_APP_API_SERVER}/api/${process.env.VUE_APP_API_VERSION2}/connector/`;
const tokenUrl = `https://${process.env.VUE_APP_API_CLIENT}.${process.env.VUE_APP_API_SERVER}/`;

const apiCall = ({ url, data, method, params }) =>
    new Promise((resolve, reject) => {
        var token = store.state.auth.token;
        if (token)
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            try {
                if (method == "GET") {
                    resolve(axios.get(apiUrl + url, {
                        params: params
                    }));
                }
                if (method == "POST") {
                    resolve(axios.post(apiUrl + url, data, {
                        params: params
                    }));
                }
            } catch (err) {
                reject(new Error(err));
            }
    });

    const apiCall2 = ({ url, data, method, params }) =>
    new Promise((resolve, reject) => {
        var token = store.state.auth.token;
        if (token)
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            try {
                if (method == "GET") {
                    resolve(axios.get(apiUrl2 + url, {
                        params: params
                    }));
                }
                if (method == "POST") {
                    resolve(axios.post(apiUrl2 + url, data, {
                        params: params
                    }));
                }
            } catch (err) {
                reject(new Error(err));
            }
    });

const tokenApiCall = ({ url, data, method, params }) =>
    new Promise((resolve, reject) => {
       // setTimeout(() => { 
            try {
                if (method == "GET") {
                    resolve(axios.get(tokenUrl + url, {
                        params: params
                    }));
                }
                if (method == "POST") {
                    resolve(axios.post(tokenUrl + url, data, {
                        params: params
                    }));
                }
            } catch (err) {
                reject(new Error(err));
            }

       // }, 1000);

    });

const apiCalls = { apiCall: apiCall, apiCall2: apiCall2, tokenApiCall: tokenApiCall };
export default apiCalls;
